import moment from 'moment';

export const convertISODate = (date) => {
  const stringDate = moment(date).format('DD/MM/YYYY');
  return stringDate;
};
